module.exports = require("next/router");